import pkg from '../../package.json'

const { name, version } = pkg
const PREFIX = `${name}-${version}-${process.env.NODE_ENV}-`

function isNull (data) {
  return data === undefined || data === null
}
function formatName (name) {
  return PREFIX + name
}
function formatData (data) {
  return JSON.stringify(data)
}
function parseData (data, defaultVal) {
  if (!data) return data || defaultVal
  let res
  try {
    res = JSON.parse(data)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
  return res || defaultVal
}

export function setLocalStorage (name, data) {
  if (isNull(data)) return
  window.localStorage.setItem(formatName(name), formatData(data))
}
export function getLocalStorage (name, defaultVal) {
  return parseData(window.localStorage[formatName(name)], defaultVal)
}
export function removeLocalStorage (name) {
  window.localStorage.removeItem(formatName(name))
}
export function setSessionStorage (name, data) {
  if (isNull(data)) return
  window.sessionStorage.setItem(formatName(name), formatData(data))
}
export function getSessionStorage (name, defaultVal) {
  return parseData(window.sessionStorage[formatName(name)], defaultVal)
}
export function removeSessionStorage (name) {
  window.sessionStorage.removeItem(formatName(name))
}
